import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetTaskTemplates = () => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.TaskTemplates], () => api.base
        .get(`${config.appUrls.tasks}/api/TaskTemplates`)
        .then(res => res.data), {
        enabled: true,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
